export interface MaterialPreview {
  image: string
  title: string
  caption: string
}

export const materialPreviews: MaterialPreview[] = [
  {
    image:
      'https://cdn.magicpatterns.com/uploads/v8XhKnugU7sAc2Bvj2rD9B/Captura_de_pantalla_2026-09-08_a_la(s)_9.02.27_p._m..png',
    title: 'Imprint e Neutro Alternati',
    caption: 'Posizione del bacino a confronto, con esecuzione, regressione e progressione.',
  },
  {
    image:
      'https://cdn.magicpatterns.com/uploads/hx6pRmeS4LLtNsujeQrPkx/Captura_de_pantalla_2026-09-08_a_la(s)_9.02.49_p._m..png',
    title: 'Footwork Arches e Heels',
    caption: 'Punti di appoggio evidenziati sulla foto, ripetizioni ed errori frequenti.',
  },
  {
    image:
      'https://cdn.magicpatterns.com/uploads/tBuU6jzEBRghVEZo9ZiZ15/Captura_de_pantalla_2026-09-08_a_la(s)_9.03.21_p._m..png',
    title: 'Arm Circles',
    caption: 'Schema del movimento con le direzioni del cerchio ed esecuzione passo per passo.',
  },
  {
    image:
      'https://cdn.magicpatterns.com/uploads/dYCFM8AVbt8gFgxT48WhEP/Captura_de_pantalla_2026-09-08_a_la(s)_9.03.37_p._m..png',
    title: 'Pelvic Curl',
    caption: 'Montaggio del Reformer, molle e footbar, con la sequenza di articolazione della colonna.',
  },
  {
    image:
      'https://cdn.magicpatterns.com/uploads/7vm7DXLESYUJEEB79uwfTx/Captura_de_pantalla_2026-09-08_a_la(s)_9.06.13_p._m..png',
    title: 'Mini-sequenza da 30 minuti · 2º trimestre',
    caption: 'Lezione completa già pronta, esercizio per esercizio con tempi e carichi.',
  },
]
